import React from 'react';
import { LineChart, X, Zap } from 'lucide-react';
import { Input } from './ui/input';

const SLOTS = [0, 1, 2];

const CompetitorUrlsEditor = ({ urls = [], onChange, compact = false, autoAlign, autoOffset, onAutoChange }) => {
  const setSlot = (i, value) => {
    const next = SLOTS.map(k => (k === i ? value : urls[k] || ''));
    onChange(next);
  };
  return (
    <div data-testid="competitor-urls-editor">
      {!compact && (
        <h3 className="font-semibold text-gray-900 flex items-center gap-2 mb-1"><LineChart size={18} className="text-orange-500" /> Prix concurrents</h3>
      )}
      <p className="text-xs text-gray-500 mb-2">Jusqu'à 3 URLs de concurrents vendant exactement ce produit. Les prix sont relevés automatiquement chaque mois (onglet « Veille tarifaire »).</p>
      <div className="space-y-2">
        {SLOTS.map(i => (
          <div key={i} className="flex items-center gap-2">
            <span className="text-xs text-gray-500 w-24 shrink-0">Concurrent {i + 1}</span>
            <Input
              type="url"
              placeholder="https://www.concurrent.fr/produit..."
              value={urls[i] || ''}
              onChange={(e) => setSlot(i, e.target.value)}
              data-testid={`competitor-url-${i + 1}`}
              className="text-sm"
            />
            {urls[i] ? (
              <button type="button" onClick={() => setSlot(i, '')} className="p-1.5 text-gray-400 hover:text-red-600" title="Supprimer" data-testid={`competitor-url-clear-${i + 1}`}><X size={14} /></button>
            ) : <span className="w-7" />}
          </div>
        ))}
      </div>
      {onAutoChange && (
        <div className="mt-3 flex flex-wrap items-center gap-3 text-sm bg-orange-50/60 border border-orange-100 rounded-lg px-3 py-2" data-testid="product-form-auto-align">
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" checked={!!autoAlign} onChange={(e) => onAutoChange(e.target.checked, autoOffset)} data-testid="product-form-auto-align-toggle" className="rounded border-gray-300 text-orange-500" />
            <span className="flex items-center gap-1.5 font-medium text-gray-800"><Zap size={14} className="text-orange-500" /> Alignement automatique après chaque relevé</span>
          </label>
          <span className="flex items-center gap-1.5 text-gray-600">Écart (€)
            <Input type="number" step="0.01" min="0" value={autoOffset ?? 0.1} onChange={(e) => onAutoChange(autoAlign, e.target.value)} disabled={!autoAlign} data-testid="product-form-auto-align-offset" className="w-24 h-8" />
          </span>
          <span className="text-xs text-gray-500 basis-full">Ne franchit jamais la marge HT plancher définie dans la Veille tarifaire. Nécessite un prix d'achat fournisseur.</span>
        </div>
      )}
    </div>
  );
};

export default CompetitorUrlsEditor;
